// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-bdqkcx-index-main_right_content-QAgBT","table":"components-tjcx-bdqkcx-index-table-2TAi6"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/bdqkcx/index.css
// module id = 363
// module chunks = 0